import React, { useState } from "react";

import { Button, LoadingBox } from "components";
import { Filters } from "./CustomerReportFilters";

import * as XLSX from "xlsx";
import download from "downloadjs";

import axios from "axios";
import { Routes } from "clients/apis/_routes";

const excelMimType =
  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";

const ExportExcel: React.FC<{ filters: Filters }> = (props) => {
  const {
    popularGroups,
    friendships,
    customerGroups,
    colleagueCompanies,
    cities,
    creators,
    customerTypes,
    mobile,
    noAddress,
  } = props.filters;

  const [isLoading, setIsLoading] = useState(false);

  const getAllData = async () => {
    const _popularGroup =
      popularGroups?.id === null ? "null" : popularGroups?.id;
    const _friendships = friendships?.map((f) =>
      f?.id === null ? "null" : f?.id
    );
    const _customerGroups = customerGroups?.map((c) => c?.id);

    const _colleagueCompanies = colleagueCompanies?.map((co) =>
      co?.id === null ? "null" : co?.id
    );
    const _creators = creators?.map((c) => c?.id);
    const _cities = cities?.filter((e) => e?.id)?.map((e) => e?.id);
    const _noAddress = cities?.some((e) => e.id === null) ? "true" : undefined;

    let qs = `?page=1&pagination=500`;
    qs += noAddress ? "&noAddress=" + _noAddress : "";
    qs += mobile ? "&phone=" + mobile : "";
    qs += customerTypes ? "&customer_types=" + customerTypes?.id : "";
    qs += _popularGroup ? "&popular_groups=" + _popularGroup : "";

    qs += _cities?.length > 0 ? "&cities[]=" + _cities : "";
    qs += _creators?.length > 0 ? "&creators[]=" + _creators : "";
    qs += _friendships?.length > 0 ? "&friendships[]=" + _friendships : "";
    qs +=
      _customerGroups?.length > 0
        ? "&customer_groups[]=" + _customerGroups
        : "";
    qs +=
      _colleagueCompanies?.length > 0
        ? "&colleague_companies[]=" + _colleagueCompanies
        : "";

    return await axios.get(Routes.BASE_URL + Routes.CUSTOMER_REPORT + qs);
  };

  const _onExcel = () => {
    setIsLoading(true);
    getAllData().then((res) => {
      if (res?.data) {
        const json = res?.data?.data?.map((u: CustomerT) => {
          return {
            نام: u?.name,
            موبایل: u?.mobile,
            "کد ملی": u?.national_code,
            "ایجاد کننده": u?.seller,
            تولد: u?.birthday,
            گروه: u?.category?.title,
            نوع: u?.status?.title,
            شهر: u.cityName,
            "نحوه آشنایی": u?.frindship?.title,
            سمت: u?.job,
            ایمیل: u?.email?.join(" , "),
            تلفن: u?.phone?.map((p) => p.number).join(" , "),
            "شبکه اجتماعی": u?.social?.map((s) => s.address)?.join(" , "),
            مذهب: u?.religion?.title,
            "توضیحات مشتری": u?.shop?.description,
          };
        });

        var ws = XLSX.utils.json_to_sheet(json);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Cities");
        const wbOut = XLSX.write(wb, {
          type: "base64",
          bookType: "xlsx",
        });
        download(excelMimType + wbOut, "customers.xlsx", excelMimType);
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Button
        onPress={_onExcel}
        square={45}
        icon={{
          type: "materialCommunity",
          name: "microsoft-excel",
          size: 35,
        }}
      />
      {isLoading && <LoadingBox />}
    </>
  );
};

export default ExportExcel;
